import { connect } from 'react-redux';

import { selectThemeMode } from './selectors';
import { RootState } from 'types';
import { ThemeMode } from 'reducers/constants';

import { useStyles } from './styles';

interface OwnProps {
  readonly isAnimated: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const BackgroundLogo = ({ isAnimated, theme }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 4096 666.92"
      enableBackground="new 0 0 4096 666.92"
      xmlSpace="preserve"
      className={isAnimated ? 'animated' : ''}
    >
      <g id="logo">
        <circle
          id="outer-circle"
          fill="none"
          stroke="#010101"
          strokeWidth="4"
          strokeMiterlimit="10"
          cx="2525.08"
          cy="263.61"
          r="261.61"
        />
        <g id="XMLID_9_">
          <g>
            <path
              fill="#FFFFFF"
              d="M2691.18,77.71l-13.28,13.6c-36.58-35.74-83.54-53.43-83.54-53.43l-2.67,8.76
				c-39.51-13.31-88.38-15.81-138.73,12.65l-15.55-19.06c26.31-15.87,58.91-25.32,102.33-26.34
				C2606.45,12.33,2655.94,45.16,2691.18,77.71z"
            />
            <path
              fill="#ED2224"
              d="M2672.35,96.71l-12.88,13.72c-26.22-22.94-51.08-36.69-73.7-44.38
				c-70.48-23.93-119.07,11.17-119.07,11.17l15.49,19.81c-6.24,3.28-12.15,7.05-17.58,11.2l-16.3-17.9c0,0-25.03,22.65-32.02,33.01
				l-18.68-11.14c13.37-17.4,36.34-38.98,36.34-38.98L2417.8,54.1c6.15-5.05,12.65-9.69,19.61-13.86l15.55,19.06
				c50.35-28.45,99.23-25.96,138.73-12.65C2629.37,59.32,2658.55,81.83,2672.35,96.71z"
            />
            <path
              fill="#FFFFFF"
              d="M2653.59,116.46l-11.63,12.5c-22.62-21.06-62.83-44.78-99.81-46c-21.17-0.7-42,4.67-59.95,14.07
				l-15.49-19.81c0,0,48.58-35.1,119.07-11.17l-2.18,7.16C2628.06,91.57,2653.59,116.46,2653.59,116.46z"
            />
            <path
              fill="#FFFFFF"
              d="M2448.31,90.32l16.3,17.9c-10.65,8.15-19.58,17.87-25.96,28.48l-22.36-13.37
				C2423.28,112.98,2448.31,90.32,2448.31,90.32z"
            />
            <path
              fill="#FFFFFF"
              d="M2417.8,54.1l16.16,19.11c0,0-22.97,21.58-36.34,38.98l-21.03-12.59
				C2388.97,82.2,2402.25,66.83,2417.8,54.1z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2397.61,112.19l-21.03-12.59c12.39-17.4,25.67-32.78,41.22-45.51"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2416.29,123.33l22.36,13.37c6.38-10.62,15.31-20.33,25.96-28.48"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2482.19,97.02c17.95-9.4,38.78-14.76,59.95-14.07
				c36.98,1.22,77.18,24.94,99.81,46l11.63-12.5c0,0-25.52-24.89-69.99-43.25l2.18-7.16"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2591.69,46.64l2.67-8.76c0,0,46.96,17.69,83.54,53.43l13.28-13.6
				c-35.24-32.54-84.73-65.38-151.44-63.81c-43.42,1.02-76.02,10.47-102.33,26.34"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2591.69,46.64c-39.51-13.31-88.38-15.81-138.73,12.65
				l-15.55-19.06c-6.96,4.18-13.46,8.82-19.61,13.86l16.16,19.11c0,0-22.97,21.58-36.34,38.98l18.68,11.14
				c6.99-10.36,32.02-33.01,32.02-33.01l16.3,17.9c5.42-4.15,11.34-7.92,17.58-11.2l-15.49-19.81c0,0,48.58-35.1,119.07-11.17
				c22.62,7.69,47.48,21.44,73.7,44.38l12.88-13.72C2658.55,81.83,2629.37,59.32,2591.69,46.64z"
            />
          </g>
        </g>
        <circle
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          cx="2524.39"
          cy="111.02"
          r="37.8"
        />
        <path
          fill="#010101"
          d="M2399.78,115.1c-0.34,0.67-0.1,0.88,0.32,1.2c0.43,0.31,5.07,2.86,5.07,2.86l0.2-0.35l21.7,12.26l0.29-0.51
		l4.1,2.32l0.7,1.17l6.85,3.87c0,0,0.07,0.6,0.74,1.18c0.67,0.58,1.47,0.19,1.67-0.1l4.29,2.42l-1.01,1.78c0,0-0.56,0.81,0.25,1.4
		c0.81,0.58,2.07,1.27,2.07,1.27l-0.04,3.02c0,0,0.47,0.73,1.16,0.47c0.68-0.26,1.22-0.64,1.22-0.64l26.4,14.91
		c0,0,0.96,0.5,1.35-0.12c0.39-0.62,0.52-0.92,0.52-0.92l0.54,0.31c0,0,1.59,2.29,1.93,2.37c0.34,0.08,0.58-0.39,0.85-0.86
		c0.27-0.47,0.58-0.97,0.58-0.97l1.01,0.57l-0.77,1.36c0,0,0.96,3.08,0.75,3.59c-0.22,0.51-5.64,10.2-11.04,16.32
		c-5.4,6.12-6.01,6.5-6.46,6.91c-0.45,0.41-1.3,0.82-0.62,1.88c0.68,1.05,8.16,8.28,8.16,8.28s1.16,1.1,2.25,0.16
		c1.09-0.94,12.04-13.15,15.1-18.27c0,0,2.75,3,5.23,4.51c2.48,1.51,5.31,1.61,5.31,1.61s1.71,0.52,1.55,2.27
		c-0.15,1.75-1.44,11.7-1.44,11.7s0.02,0.85-0.86,1.24c-0.89,0.39-0.86,1.24-0.07,1.8c0.8,0.56,9.91,1.26,9.91,1.26
		s1.37-0.06,1.4-1.88c0.03-1.82-0.04-14.2-0.04-14.2s0.26-2.13,2.13-2.69c1.87-0.56,2.85-0.12,3.29-0.7c0.44-0.58,1-1.27,1-1.27
		l1.11,0.79c0,0-0.67,1.68,0.14,2.41c0.81,0.73,2,0.4,2.67-0.49c0.67-0.9,1.18-2.2,1.18-2.2l1.68,0.95l12.92,26.67
		c0,0-1.06,1.14-0.2,2.32c0.86,1.18,3.26,1.84,3.26,1.84s1.08,0.68,2.57-0.98c1.49-1.66,5.29-8.88,8.34-11.82
		c3.05-2.93,4.62-5.1,5.37-6.55c0.75-1.45,1-3.25-0.04-3.98c-1.05-0.73-1.83-0.2-1.83-0.2l-32.85-18.55c0,0,1.32-2.1,0.62-2.7
		c-0.7-0.6-1.42-0.8-1.42-0.8s-0.03-1.06-0.53-1.27c-0.5-0.22-5.95-3.36-5.95-3.36l3.78-6.68c0,0,0.37-0.9-0.67-1.28
		c-1.04-0.38-3.29,0.29-4.57,3.18l-5.03-1.17c0,0-0.81-0.04-1.23,0.7c-0.42,0.74-0.95,1.69-0.95,1.69l-0.64-0.36l0.48-0.86
		l-0.95-0.53l-0.48,0.85l-1.03-0.58l0.47-0.85l-0.95-0.53l-0.47,0.84l-1.03-0.58l0.47-0.84l-0.95-0.53l-0.47,0.84l-1.03-0.58
		l0.47-0.83l-0.95-0.53l-0.46,0.83l-1.03-0.58l0.46-0.82l-0.95-0.53l-0.46,0.82l-1.03-0.58l0.46-0.82l-0.95-0.53l-0.45,0.81
		l-1.03-0.58l0.45-0.81l-0.95-0.53l-0.45,0.8l-1.03-0.58l0.45-0.8l-0.95-0.53l-0.44,0.8l-1.03-0.58l0.44-0.79l-0.95-0.53l-0.44,0.79
		l-0.76-0.43c0,0-0.65-0.09-1.02,0.33c-0.37,0.41-0.42,0.74-0.42,0.74c-0.35-0.48-0.58-0.33-0.58-0.33s0.84-1.12,0.18-1.43
		c-0.66-0.3-3.25-1-3.25-1l0.39-0.68c0,0,0.3-0.53-0.84-1.1c-1.14-0.57-29.16-15.99-29.16-15.99l-1.51,0.33l-1.27-11.27
		c0,0,0.02-1.38-1.38-1.61c-1.4-0.23-1.95,0.5-2.61,1.79c-0.66,1.29-4.98,8.79-4.98,8.79l-6.99-3.95l-1.08-0.05l-4.21-2.38
		l0.36-0.63l-21.73-12.27l0.22-0.38l-5.25-2.97c0,0-0.5-0.27-0.83,0.19C2401.19,112.65,2400.12,114.43,2399.78,115.1z
		 M2533.08,203.13c0.4-0.63,0.78-0.19,0.78-0.19s2.46,4.64,2.42,5.6c-0.04,0.96-0.87,0.36-0.87,0.36S2532.68,203.76,2533.08,203.13z
		 M2533.02,195.72c0.6-0.43,1.26-0.1,1.26-0.1l6.7,6.26c0,0,1.09,0.3,0.76-0.65c-0.32-0.94-1.92-3.36-1.92-3.36l6.34,3.55
		c0,0,1.08,0.38,0.29,1.95c-0.79,1.57-5.64,7.68-5.64,7.68s-1.52,1.92-2.25,0.58s-5.77-14.64-5.77-14.64
		S2532.42,196.14,2533.02,195.72z M2493,181.03c0.97-1.33,3.16-1.1,3.16-1.1l2.87,1.51c0,0,0.67,0.96,0.25,2.51
		c-0.42,1.55-2.06,2.47-2.26,2.76c-0.21,0.29,1.71-0.03,2.81-1.34c1.09-1.31,1.24-3.02,1.24-3.02c0.89,0.72,2.02,2.79,1.13,4.39
		c-0.9,1.6-3.6,3.33-7.07,0.97C2491.64,185.36,2492.03,182.36,2493,181.03z M2445.21,129.65c0,0,0.4,0.28,0.99,0.56
		c0.59,0.28,0.81-0.41,0.81-0.41l0.79-1.42l1.2,0.67c0,0,1.2,5.64,1,6.55c-0.2,0.91-1.09,0.42-1.09,0.42s-4.28-2.42-4.9-2.74
		c-0.62-0.32-0.3-0.95-0.3-0.95L2445.21,129.65z"
        />
        <path
          fill="#010101"
          d="M2435.66,137.79l-9.03-5.23l1.29-2.13l-1.29-0.89l-1.49,2.18l-43.06-25.1c0,0-5.44-3.2-9.33-2.88
		c1.46,3.23,6.76,6.15,6.76,6.15l43.34,25.5l-1.34,2.39l1.57,0.96l1.56-2.46l11.41,6.4c0,0-0.99,3.33,1.89,1.94l2.14-4.53
		c0,0,0.93-3.11-2.44-1.22L2435.66,137.79z"
        />
        <g id="XMLID_8_">
          <g>
            <path
              fill="#F6EB16"
              d="M2459.39,137.81c0.96,0.52,1.83,1.13,2.67,1.8c1.25,0.99,2.38,2.06,3.31,3.07
				c1.36,1.48,2.35,2.81,2.87,3.63c-0.61,0.03-9.75,0.55-3.54,6.35c0.35,1.16,2.09,0.93,3.13,2.44c1.74,3.54-0.64,6.35-0.64,6.35
				l26.05,19.9l-11.95,10.24l-2.93-8.12c-9.31-17.35-22.13-21.87-24.19-24.92c-5.34-7.77-6.61-12.41-6.61-12.41
				s-0.38-7.16,2.73-10.07C2453.65,135.43,2456.72,136.3,2459.39,137.81z"
            />
            <path
              fill="#F6EB16"
              d="M2468.27,146.31c0.32,0.46,0.49,0.75,0.49,0.75c-2.9,0.58-4.26,3.68-4.15,5.25
				c0,0.12,0.03,0.23,0.09,0.35c-6.21-5.8,2.93-6.32,3.54-6.35H2468.27z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2468.27,146.31c0.32,0.46,0.49,0.75,0.49,0.75
				c-2.9,0.58-4.26,3.68-4.15,5.25c0,0.12,0.03,0.23,0.09,0.35c0.35,1.16,2.09,0.93,3.13,2.44c1.74,3.54-0.64,6.35-0.64,6.35
				l26.05,19.9l-11.95,10.24l-2.93-8.12c-9.31-17.35-22.13-21.87-24.19-24.92c-5.34-7.77-6.61-12.41-6.61-12.41
				s-0.38-7.16,2.73-10.07c3.36-0.64,6.44,0.23,9.11,1.74c0.96,0.52,1.83,1.13,2.67,1.8c1.25,0.99,2.38,2.06,3.31,3.07
				c1.36,1.48,2.35,2.81,2.87,3.63"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2459.39,137.81c0,0-7.4-1.94-7.72,8.03"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2462.06,139.6c0,0-6.93,0.44-6.64,7.6"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2465.37,142.68c0,0-6.41-0.93-7.08,7.28"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2468.27,146.31h-0.03c-0.61,0.03-9.75,0.55-3.54,6.35"
            />
          </g>
        </g>
        <path
          id="horse"
          stroke={theme === ThemeMode.Dark ? '#FFFFFF' : 'transparent'}
          className={classes.horse}
          fill="#010101"
          d="M2630.19,270.03l4.49,8.15l0,0c0,0,10.97,14.86,2.08,36.66c0.28-0.14-2.64,6.67,6.53,10.69
		c0,0,4.86,2.22,10.14,12.5c0,0,10.28,3.19,15.14,6.94c1.39,1.81,0.56,12.77,2.64,12.08c0,0,5.14,22.63,17.5,43.18
		c0,0,4.05,8.05-3.15,12.64c0,0-1.11,3.61,1.76,6.39c2.87,2.78-8.52,6.02-8.52,6.02s0.85,12.68-2.29,20.37l-23.63,1.66l8.52-15.92
		c0,0-4.35-4.44,5.09-7.87v-10c0,0,11.39-10.28,0.09-28.51c-4.81-13.42-8.05-15.64-8.05-15.64s-3.7-1.02-6.76-8.24
		c-5.74-3.7-10.55-2.48-10.55-2.48l6.11,3.77c0,0,7.78-1.39,5.28,13.05c0,0,6.76,20.74,11.94,29.07c3.24,4.17-4.63,7.59-4.63,7.59
		l-0.19,2.31c0,0,7.68,11.39-5.74,11.39c2.68,6.39-2.13,7.59-2.13,7.59l-2.43,11.55l-23.77,1.6l8.79-14.44c0,0-1.11-5.46,5.18-6.48
		c-6.94-7.13,6.29-13.52,6.29-13.52s5.37-13.61-8.89-30.36c0,0-6.02-2.41-10.09-11.39c0,0-8.1-0.83-11.71-5.69
		c0,0-38.88-4.58-46.93-34.85c-3.89-10.69-20.41-6.53-20.41-6.53s-54.71,24.02-95.95-24.44c-12.08,5.97-23.19-1.67-23.19-1.67
		c-13.47,4.03-29.85,0-29.85,0s0.14,2.64-4.58,7.08l-2.64,24.86c5.97,9.58-1.53,10.69-1.53,10.69s-1.39,4.17,10.14,6.25l-0.97,23.05
		c0,0-11.66-4.3-13.75-12.36c-6.67-1.25-5.42-7.64-5.42-7.64s0.69-4.58-4.86-5.69c-3.33-10.28,1.81-13.89,1.81-13.89l1.67-23.47
		c0,0-14.02-32.21,15.69-27.22c11.8-1.25-11.94-3.75-11.94-3.75c-11.9-2.78-9.95-3.98-9.95-3.98s-0.93,2.59-10.28,5.28l-1.2,20.27
		c7.5,11.66-1.39,13.42-1.39,13.42v1.67c0,0,4.35-1.2,5.09,5.28l7.31,5.55l-6.57,22.96c0,0-8.05-3.52-11.48-14.81
		c-2.5-4.81-5.74-5.92-5.74-5.92l-0.37-8.05c0,0-0.93-2.13-3.98-2.87c-3.05-0.74,4.54-37.21,4.54-37.21s-4.54-28.42,15.27-25.19
		c20.83,2.87,26.2,2.24,41.38,0.66c0,0,0.56-13.89,7.04-17.68c6.94-10.09,7.23-26.84,7.23-26.84c-1.12-20.46-8.24-2.6-8.24-2.6
		c-6.39,6.29-10.09,6.2-10.09,6.2s-3.15,10.09-8.7,15.83c-0.74,13.05-5.92,20.09-14.26,14.16c8.24-17.22-3.7-0.09-3.7-0.09
		s-9.26,6.48-9.91-17.59c2.31-9.53,1.3-44.06,1.3-44.06c-1.02-5.55-10.28-10.55-10.28-10.55c7.87-2.13,11.02-8.42,11.02-8.42
		c-3.15-0.65-5-2.68-5-2.68s7.04-1.94,7.87-4.26c0.83-2.31-4.44-9.16-4.44-9.16s11.11,4.26,15.83,4.35
		c-6.2-11.76-4.72-16.2-4.72-16.2c19.25,0.56,21.48,15.83,21.48,15.83c10.65-10.55,24.9-6.67,24.9-6.67
		c-0.83,3.24-4.26,4.63-4.26,4.63c8.7,1.94,15-3.24,15-3.24c0.46,2.96-1.76,6.2-1.76,6.2c8.42-0.65,14.26,1.85,14.26,1.85
		c2.96,2.87,11.48-0.09,11.48-0.09c0.46,3.89-2.68,6.76-2.68,6.76s11.02,9.72,18.05,8.05c-0.28,3.61-3.15,4.35-3.15,4.35
		s15.03,14.71,24.35,47.95c8.89,31.1,105.81,30.52,105.81,30.52c13.06,0.03,20.55,10.58,20.55,10.58s12.5,0.74,37.31-7.96
		c43.14,4.88,51.47,64.15,51.47,64.15s-6.94-3.8-10-12.13c7.87,37.21,16.94,38.88,16.94,38.88s-15.55,10.83-24.72-22.12
		c0.83,17.22,3.8,20.55,3.8,20.55s-8.33,1.2-14.44-21.85c-0.93,16.01,4.44,19.25,4.44,19.25s-15.37-2.68-13.05-32.21
		c0,0-3.26,10.36-0.76,20.27c0,0-17.02-9.44-9.43-32.58c-5.37,8.98-3.52,15.18-3.52,15.18s-8.33-5.92-6.85-25.64
		C2649.26,263.74,2630.19,270.03,2630.19,270.03z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2405.82,244.48l4.81-8.8c36.32,25.68,99.07,38.3,99.07,38.3
		l-1.68,8.27C2449.42,274.05,2405.82,244.48,2405.82,244.48z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2630.51,269.09c0,0-6.72,5.3-25.06,10
		c-1.44-22.89-12.39-31.55-12.39-31.55l-11.61,1.65c10.51,6.1,13.18,22.94,12.97,32.34c-14.54,2.76-34.22,4.84-60.37,4.69
		l-1.07,10.17c0,0,56.75,4.39,102.15-19.27L2630.51,269.09z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2514.7,294.96c-1.5,23.18-17.14,31.4-17.14,31.4
		c4.38,3.91,11.77,3.22,11.77,3.22c20.2-10.54,16.78-34.62,16.78-34.62H2514.7z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2405.23,150.45c-11.9,18.84-25.72,63.63-25.72,63.63h5.91
		c6.95-23.2,26.9-63.33,26.9-63.33L2405.23,150.45z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2366.85,172.11c12.98-4.34,25.96,0.29,25.96,0.29l-1.41,5.92
		c-13.88-3.78-24.56,0-24.56,0V172.11z"
        />
        <circle
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          cx="2394.71"
          cy="178.32"
          r="6.22"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2364.97,215.37c9.43-4.77,16.02-0.73,16.02-0.73v4.29
		c-10.88-0.83-16.02,2.9-16.02,2.9V215.37z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2381.62,220.91c0.49,8.35-1.64,12.8-1.64,12.8h2.18
		c3.23-6.54,1.93-13.08,1.93-13.08L2381.62,220.91z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2385.74,215.47c70.74-7.42,107.64-21.34,107.64-21.34l1.6,5.46
		c-62.93,17.85-109.14,21.03-109.14,21.03L2385.74,215.47z"
        />
        <circle
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          cx="2382.11"
          cy="218.11"
          r="4.5"
        />
        <path
          fill="#F6EB16"
          d="M2384.65,181.8c-9.21-0.73-9.21,10.28-9.21,10.28C2387.24,189.32,2384.65,181.8,2384.65,181.8z"
        />
        <path
          fill="#FAA85E"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2544.41,142.83l-12.51,5.43c-1.65,0.72-3.59-0.05-4.3-1.7
		l-8.71-20.08c-0.72-1.65,0.05-3.59,1.7-4.3l12.51-5.43c1.65-0.72,3.59,0.05,4.3,1.7l8.71,20.08
		C2546.83,140.18,2546.06,142.11,2544.41,142.83z"
        />
        <g id="XMLID_7_">
          <g>
            <path
              fill="#29ABE2"
              d="M2654.05,194.31c-11.14-3.25-0.9-16.19,3.63-23.87c5.02-8.24-1.22-8.53-2.52-8.5
				c0.73-0.9,1.48-1.77,2.23-2.64l4.81-4.61c9.02-8.99,20.62-10.62,26.48-3.6c2.09,2.49,3.45,6.09,3.71,10.85
				c0.55,10.44-29.03,41.39-10.01,34.78c-4.9,7.86-10.65,8.67-13.28,5.25c0,0-5.19,0.44-7.89-2.38h-0.03
				C2660.69,199.5,2655.62,198.43,2654.05,194.31z"
            />
            <path
              fill="#29ABE2"
              d="M2595.2,199.39c-5.71,0.96-9.98-1.36-9.46-10.82c2.06,5.86,6.06,5.71,10.7,2.58
				c2.47-1.65,5.1-4.15,7.74-7.02c2.2-2.41,4.38-5.08,6.41-7.74c2.96-3.86,5.66-7.72,7.74-10.76c8.53-12.47,21.75-31.33,34.57-25.53
				l0.06,0.15c9.83-4.84,15.92,1.28,15.92,1.28c14.01-3.6,19.52,8.88,19.78,9.57c-5.86-7.02-17.46-5.4-26.48,3.6l-4.81,4.61
				c-0.75,0.87-1.51,1.74-2.23,2.64c-9.63,11.92-15.81,26.66-22.45,36.08c-14.27,14.53-26.95,4.93-26.95,4.93
				C2599.05,203.3,2595.2,199.39,2595.2,199.39z"
            />
            <path
              fill="#29ABE2"
              d="M2558.74,133.86c2.67-1.57,5.45-2.7,8.27-2.78c6.9,0,8.59,3.39,8.59,3.39l0.03,0.12
				c28.89-5.6,34.98,41.8,34.98,41.8c-2.03,2.67-4.21,5.34-6.41,7.74c-2.64,2.87-5.28,5.37-7.74,7.02
				c-4.64,3.13-8.64,3.28-10.7-2.58c0,0,5.28-29.06-18.68-21.75c0,0-3.74-11.83-38.75-16.5l0.67-5.4c6.18,0,16.13-10.18,16.13-10.18
				C2552.15,130.58,2558.74,133.86,2558.74,133.86z"
            />
            <path
              fill="#29ABE2"
              d="M2528.98,144.91l-0.67,5.4c-4.73-0.64-10.01-1.13-15.95-1.45c0.96-7.16,11.92-9.54,11.92-9.54
				C2524.77,143.43,2526.6,144.91,2528.98,144.91z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2543.86,142.51
				c3.68,0.15,8.99-5.22,14.88-8.64c2.67-1.57,5.45-2.7,8.27-2.78c6.9,0,8.59,3.39,8.59,3.39"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2557.9,143.2
				c6.7-4.96,12.59-7.63,17.72-8.61c28.89-5.6,34.98,41.8,34.98,41.8"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2620.93,184.97
				c0,0-15.32,12.68-25.73,14.42c-5.71,0.96-9.98-1.36-9.46-10.82c0,0,5.28-29.06-18.68-21.75c0,0-3.74-11.83-38.75-16.5
				c-4.73-0.64-10.01-1.13-15.95-1.45c0.96-7.16,11.92-9.54,11.92-9.54c0.49,4.12,2.32,5.6,4.7,5.6c6.18,0,16.13-10.18,16.13-10.18
				c7.05-4.15,13.63-0.87,13.63-0.87"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2619.82,196.72
				c-5.48,4.5-10.24,6.06-14.07,6.24c-6.7,0.35-10.56-3.57-10.56-3.57"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2657.39,159.3
				c-0.75,0.87-1.51,1.74-2.23,2.64c-9.63,11.92-15.81,26.66-22.45,36.08c-14.27,14.53-26.95,4.93-26.95,4.93"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2655.15,161.94
				c1.31-0.03,7.54,0.26,2.52,8.5c-4.52,7.69-14.76,20.62-3.63,23.87"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2654.95,161.94c0,0,0.09,0,0.2,0"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2660,178.68
				c-6.38,7.6-7.16,12.5-5.95,15.63c1.57,4.12,6.64,5.19,7.14,5.28"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2667.31,179.23
				c-8.96,11.95-8.7,17.66-6.12,20.36h0.03c2.7,2.81,7.89,2.38,7.89,2.38"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2675.46,154.4
				c12.65-5.51,14.44,13.05,1.57,24.83c-9.95,10.12-10.82,19-7.92,22.74c2.64,3.42,8.38,2.61,13.28-5.25
				c0.09-0.15,0.2-0.32,0.29-0.46"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2662.2,154.69
				c9.02-8.99,20.62-10.62,26.48-3.6c2.09,2.49,3.45,6.09,3.71,10.85c0.55,10.44-29.03,41.39-10.01,34.78"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2652.92,140.1
				c-12.82-5.8-26.05,13.05-34.57,25.53c-2.09,3.05-4.79,6.9-7.74,10.76c-2.03,2.67-4.21,5.34-6.41,7.74
				c-2.64,2.87-5.28,5.37-7.74,7.02c-4.64,3.13-8.64,3.28-10.7-2.58"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2586.52,150.22
				c20.19,10.09,17.66,33.91,17.66,33.91"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2587.37,160.55
				c11.25,8.79,9.08,30.6,9.08,30.6"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2639.6,152.16
				c4.96-6.41,9.46-10.04,13.37-11.92c9.83-4.84,15.92,1.28,15.92,1.28"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M2658.49,146.42
				c3.92-2.61,7.37-4.15,10.41-4.9c14.01-3.6,19.52,8.88,19.78,9.57c0.03,0.03,0.03,0.03,0.03,0.03"
            />
          </g>
        </g>
        <polygon
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          points="2457.76,320.64 2486.24,267.78 2493.38,269.57 
		2465.57,323.73 	"
        />
        <g id="XMLID_6_">
          <g>
            <path
              fill="#F6EB16"
              d="M2573.18,240.83c6.5-0.44,8.99,9.57,0.78,7.19c-0.58-0.15-1.1,0.38-1.02,0.96
				c6.18,37.68-20.74,58.42-55.66,50.47c-23.78-5.42-57.11-21.93-26.86-58.45c30.28-36.49,16.36-4.47,16.36-4.47
				s-14.97,13.37-18.59,26.37c-3.65,13.02,22.68,32.78,51.66,28.69c30.22-4.26,26.05-43.1,26.05-43.1
				C2567.15,242.84,2569.18,241.1,2573.18,240.83z"
            />
            <path
              fill="#ED2224"
              d="M2565.9,248.49c0,0,4.18,38.84-26.05,43.1c-28.98,4.09-55.31-15.66-51.66-28.69
				c3.63-12.99,18.59-26.37,18.59-26.37S2553.52,254.03,2565.9,248.49z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2565.9,248.49c0,0,4.18,38.84-26.05,43.1
				c-28.98,4.09-55.31-15.66-51.66-28.69c3.63-12.99,18.59-26.37,18.59-26.37S2553.52,254.03,2565.9,248.49z"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2506.79,236.54c0,0,13.92-32.02-16.36,4.47
				c-30.25,36.52,3.07,53.02,26.86,58.45c34.92,7.95,61.84-12.79,55.66-50.47c-0.09-0.58,0.44-1.1,1.02-0.96
				c8.21,2.38,5.71-7.63-0.78-7.19c-4,0.26-6.03,2-7.28,7.66"
            />
          </g>
        </g>
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2554.48,254.3c-11.89,18.26-39.1,30.92-44.32,34.54
		c-10.91,7.55-10.34,15.24-11.19,23.91c-1.4,14.4-12.99,16.36-24.05,30.9c-4.89,6.43-24.97-2.68-24.97-2.68
		c15.19-9.34,27.91-42.62,27.91-42.62c3.36-9.51,1.97-10.67,1.4-14.26c-1.01-6.39,7.83-10.35,7.83-10.35
		c13.56-7.41,19.3-28.94,19.3-28.94L2554.48,254.3z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2502.67,292.99l-13.5-16.59c-1.77-2.17-1.99-5.05-0.38-6.25l0,0
		c1.62-1.2,4.31-0.14,5.87,2.19l11.89,17.78c0.73,1.09,0.47,2.56-0.55,3.32l0,0C2504.99,294.19,2503.5,294.01,2502.67,292.99z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2477.89,278.62L2477.89,278.62c-1.12,1.93-0.11,4.39,2.04,4.98
		l11.2,3.06c0.3,0.08,0.52-0.29,0.3-0.51l-8.2-8.21C2481.65,276.35,2479.01,276.69,2477.89,278.62z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2501.91,297.6l-21.79-1.22c-1.64-0.09-2.86-1.54-2.68-3.17l0,0
		c0.18-1.63,1.7-2.77,3.31-2.5l21.52,3.63c0.86,0.14,1.45,0.93,1.36,1.8l0,0C2503.53,297.01,2502.78,297.65,2501.91,297.6z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2430.67,338.14c26.19-8.41,32.84,0.88,35.22-0.41
		c4-2.16,2.54-5.24,2.54-5.25c0,0,0,0,0,0c1.91-0.91,7.51,1.89,7.63,4.77c-1.17-0.42-4.76,1.59-3.02,6.36c5.97,9.68-1.81,12-1.81,12
		C2447.57,349.27,2430.67,338.14,2430.67,338.14z"
        />
        <polygon
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          points="2455.48,329.36 2437.77,346.87 2463.12,358.13 
		2463.12,323.73 	"
        />
        <circle
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          cx="2460.39"
          cy="325.09"
          r="5.18"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2557.62,221.81c4.64,7.14,8.21,24.07,9.3,29.67
		c0.2,1.04-0.45,2.03-1.48,2.27c-8.73,2-46.63,9.5-65.77-6.06c-0.71-0.57-0.89-1.59-0.48-2.4l13.14-26.16
		c0.13-0.26,0.2-0.55,0.21-0.84l0.87-48.59c0.02-1.07,0.89-1.92,1.96-1.92h34.29c1,0,1.84,0.75,1.95,1.74l5.74,51.51
		C2557.36,221.3,2557.46,221.56,2557.62,221.81z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2550.28,152.57c20.76-2.78,16.18,17.2,16.24,25.25
		c0,0,6.15,27.65,3.97,34.67c-2.19,7.02-8.5,8.82-11.98,9.21c-24.71,2.78-57.3-14.66-57.3-14.66l5.81-12.25
		c0,0,25.76,13.31,32.8,8.1C2553.67,180.02,2530.82,157.06,2550.28,152.57z"
        />
        <path
          fill="#F5EB1F"
          stroke="#0D0E0E"
          strokeMiterlimit="10"
          d="M2568.92,176.5l-25.63,2.67c-0.52,0.05-0.99-0.33-1.05-0.85
		l-0.38-3.61c-0.05-0.52,0.33-0.99,0.85-1.05l25.63-2.67c0.52-0.05,0.99,0.33,1.05,0.85l0.38,3.61
		C2569.83,175.97,2569.45,176.44,2568.92,176.5z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2569.33,195.36l-25.28,3.94c-0.23,0.04-0.42,0.15-0.63,0.24
		c-0.05,0.02-0.11,0.02-0.16,0.04c-0.02,0.01-0.03,0.02-0.04,0.03c-0.3,0.16-0.55,0.36-0.77,0.61c-0.02,0.02-0.04,0.03-0.06,0.05
		c-0.52,0.61-0.8,1.41-0.67,2.25c0.07,0.44,0.26,0.82,0.51,1.16l10.04,19.97c0.68,1.36,2.36,1.91,3.72,1.23s1.91-2.36,1.23-3.72
		l-7.96-15.82c-0.27-0.54,0.06-1.2,0.66-1.29l20.31-3.13c1.53-0.25,2.58-1.7,2.33-3.23
		C2572.31,196.16,2570.86,195.11,2569.33,195.36z"
        />
        <path
          fill="#F6EB16"
          stroke="#101010"
          strokeMiterlimit="10"
          d="M2558.97,210.08l11.21,2.65c1.62,0.38,2.41,2.22,1.57,3.66
		l-0.43,0.74c-0.92,1.59-3.06,1.95-4.45,0.76l-8.27-7.08C2558.26,210.52,2558.54,209.97,2558.97,210.08z"
        />
        <path
          fill="#29ABE2"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2539.65,264.88c-5.56-2.3-10.18-5.07-8.57-13.28
		c0.28-1.45,1.26-2.69,2.57-3.36c4.7-2.42,6.01-4.32,6.01-4.32c5.27-3.73,15.82-4.52,16.31-0.55c0.49,3.98,0.57,18.91-3.81,20.29
		S2539.65,264.88,2539.65,264.88z"
        />
        <path
          fill="#010101"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2543.85,231.68c4.17,8.62,14.04-6.17,16.83-5.75
		c4.07,0.61,6.25,9.09,5.96,10.42c-0.48,2.2-11.4,4.37-12.49,7.19c-0.85,2.22,0.44,12.95,1.04,17.43c0.15,1.14-0.56,2.21-1.66,2.54
		l-5.36,1.56c-1.69,0.49-3.44-0.55-3.81-2.28l-5.75-27.45c-0.18-0.84,0.28-1.69,1.08-2.01L2543.85,231.68z"
        />
        <path
          fill="#29ABE2"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2538.69,250.46c-0.28-0.87-0.12-1.81,0.53-2.46
		c2.45-2.44,6.5-4.56,9.71-4.84c3.17-0.08,4.58,2.73,7.95,4.12c0.7,0.29,1.26,0.82,1.45,1.54c1.42,5.28-2.17,17.49-3.03,19.27
		c-1.73,3.54-12.22,4.95-14.19,1.2C2539.76,266.74,2540.63,256.43,2538.69,250.46z"
        />
        <g id="XMLID_5_">
          <g>
            <path
              fill="#FFFFFF"
              d="M2552.15,151.9c-0.52,15.78-2.73,29.82-5.92,42.23c-3.86-2.67-31.01-3.97-31.01-3.97l1.02-41.22
				C2526.42,149.23,2538.49,150.1,2552.15,151.9z"
            />
            <path
              fill="#ED2224"
              d="M2546.24,194.14c-1.89,7.31-4.12,14.07-6.58,20.25c0,0-13.46-3.39-24.68-2.38l-0.75,45.13
				c-7.08,8.24-12.27,12.15-12.27,12.15s-3.25-5.8-7.34-16.33l0.38-40.67c0,0-5.74-0.41-11.81,0.78
				c-1.31-6.53-2.41-13.52-3.25-20.97c7.11-1.89,16.1-2.26,16.1-2.26v-40.75c5.54-0.26,12.3-0.38,20.22-0.15l-1.02,41.22
				C2515.23,190.16,2542.38,191.47,2546.24,194.14z"
            />
            <path
              fill="#FFFFFF"
              d="M2514.97,212c11.23-1.02,24.68,2.38,24.68,2.38c-7.77,19.69-17.72,33.79-25.44,42.75L2514.97,212z"
            />
            <path
              fill="#FFFFFF"
              d="M2496.03,149.09v40.75c0,0-8.99,0.38-16.1,2.26c-1.42-12.65-2-26.54-1.28-41.48
				C2478.65,150.63,2484.77,149.58,2496.03,149.09z"
            />
            <path
              fill="#FFFFFF"
              d="M2494.98,212.29l-0.38,40.67c-3.71-9.6-8.15-23.15-11.43-39.88
				C2489.24,211.89,2494.98,212.29,2494.98,212.29z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2483.15,213.08h0.03c6.06-1.19,11.81-0.78,11.81-0.78l-0.38,40.67
				"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2496.03,149.06v0.03v40.75c0,0-8.99,0.38-16.1,2.26"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2546.24,194.14c-3.86-2.67-31.01-3.97-31.01-3.97l1.02-41.22
				v-0.12"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2479.93,192.11c-1.42-12.65-2-26.54-1.28-41.48
				c0,0,6.12-1.04,17.37-1.54c5.54-0.26,12.3-0.38,20.22-0.15c10.18,0.29,22.25,1.16,35.91,2.96c-0.52,15.78-2.73,29.82-5.92,42.23
				c-1.89,7.31-4.12,14.07-6.58,20.25c-7.77,19.69-17.72,33.79-25.44,42.75c-7.08,8.24-12.27,12.15-12.27,12.15
				s-3.25-5.8-7.34-16.33c-3.71-9.6-8.15-23.15-11.43-39.88C2481.87,206.55,2480.77,199.56,2479.93,192.11z"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2514.21,257.17v-0.03l0.75-45.13
				c11.23-1.02,24.68,2.38,24.68,2.38"
            />
          </g>
        </g>
        <path
          fill="#010101"
          d="M2538.16,102.65c-1.08-7.87-9.43-15.49-18.49-15.49c-7.66,0-14.16,4.27-16.57,10.21
		c-1.93,2.9-3.34,7.33-3.12,10.23c0.26,3.42,1.11,6.31,2.18,8.54c-0.04,0.51-0.07,1.03-0.07,1.56c0,2.04,0.32,3.91,0.84,5.42
		c0,0.01,0,0.02,0,0.03c-0.26,3.29,0.78,6.82,3.14,8.98c2.36,2.16,6.3,2.55,9.91,2.55c6.53,0,17.67-5.77,21.19-5.77
		c6.82,0,12.93-5.7,12.93-12.69C2550.11,109.93,2544.29,103.82,2538.16,102.65z"
        />
        <path
          fill="#FAA85E"
          d="M2533.77,109.17c4.29,11.64,2.44,24-3.31,27.24c-5.41,3.05-13.89-2.85-21.01-11.86
		c-0.91-1.15-1.66-2.43-2.22-3.78c-4.62-10.96-5.16-19.85,1.18-23.5C2515.64,93.12,2528.96,96.13,2533.77,109.17z"
        />

        <ellipse
          transform="matrix(0.957 -0.2901 0.2901 0.957 75.6113 736.0293)"
          fill="#010101"
          cx="2520.84"
          cy="112.94"
          rx="19.06"
          ry="7.05"
        />
        <g id="XMLID_4_">
          <g>
            <path
              fill="#F6EB16"
              d="M2548.85,107.23c0.32,0.96,0.26,1.65-0.17,1.94c-1.39,0.96-5.51,2.09-11.92-3.65
				c-3.16-2.81-22.48,5.31-30.6,8.9c-2.23,0.99-3.6,1.62-3.6,1.62c-0.81,3.74,2.76,6.24,2.76,6.24c-0.52,2.61-0.96,2.78-2.84,1.6
				c-4.35-2.84-3.19-10.36-3.19-10.36l42.44-14.71C2545.74,101.75,2548.21,105.12,2548.85,107.23z"
            />
            <path
              fill="#F6EB16"
              d="M2541.71,98.82l-42.44,14.71c-2.58-10.15,0.93-20.71,13.08-25.93
				C2524.48,82.41,2538.14,86.73,2541.71,98.82z"
            />
            <path
              fill="#F6EB16"
              d="M2506.15,114.43l-0.84,7.86c0,0-3.57-2.49-2.76-6.24C2502.55,116.05,2503.92,115.41,2506.15,114.43z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2499.28,113.53c-2.58-10.15,0.93-20.71,13.08-25.93
				c12.12-5.19,25.79-0.87,29.35,11.23c4.03,2.93,6.5,6.29,7.14,8.41c0.32,0.96,0.26,1.65-0.17,1.94
				c-1.39,0.96-5.51,2.09-11.92-3.65c-3.16-2.81-22.48,5.31-30.6,8.9c-2.23,0.99-3.6,1.62-3.6,1.62c-0.81,3.74,2.76,6.24,2.76,6.24
				c-0.52,2.61-0.96,2.78-2.84,1.6C2498.11,121.04,2499.28,113.53,2499.28,113.53z"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2543.1,106.19c3.42,3.13,5.74,1.04,5.74,1.04"
            />
            <line
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              x1="2499.28"
              y1="113.53"
              x2="2541.71"
              y2="98.82"
            />
            <line
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              x1="2505.31"
              y1="122.29"
              x2="2506.15"
              y2="114.43"
            />
          </g>
        </g>
        <g id="XMLID_3_">
          <g>
            <path
              fill="#111111"
              d="M2536.88,116.81c0,0,0.91,11.4-5.13,17.92l-0.01-0.03c-0.13-0.63-2.42-10.77-8.97-15.76h1.07
				c0,0,5.67-3.68,7.02-8.41c0.16-0.55,0.87-0.67,1.21-0.21L2536.88,116.81z"
            />
            <path
              fill="#111111"
              d="M2531.74,134.7l0.01,0.03c-0.19,0.21-0.4,0.42-0.61,0.62c-1.05,1-2.42,1.58-3.86,1.65
				c-1.14,0.06-2.65,0.05-4.29-0.2l-7.68-12.3v-0.01l0.35-4.3c0.05-0.7,0.64-1.25,1.35-1.25h5.76L2531.74,134.7z"
            />
            <path
              fill="#111111"
              d="M2531.74,134.7l-8.97-15.76C2529.32,123.93,2531.61,134.07,2531.74,134.7z"
            />
            <path
              fill="#111111"
              d="M2515.31,124.5l7.68,12.3C2522.99,136.8,2517.57,132.92,2515.31,124.5z"
            />
            <path
              fill="#111111"
              d="M2515.31,124.5c2.26,8.42,7.68,12.3,7.68,12.3c-4.19-0.62-9.18-2.76-10.64-9.23c0,0,2.07,0.33,2.81-1.27
				L2515.31,124.5z"
            />
            <path
              fill="#111111"
              d="M2515.31,124.49v0.01c-0.01-0.01-0.01-0.01-0.01-0.02L2515.31,124.49z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#F6EB16"
              strokeMiterlimit="10"
              d="M2515.31,124.49l0.35-4.3c0.05-0.7,0.64-1.25,1.35-1.25h5.76h1.07
				c0,0,5.67-3.68,7.02-8.41c0.16-0.55,0.87-0.67,1.21-0.21l4.81,6.49c0,0,0.91,11.4-5.13,17.92c-0.19,0.21-0.4,0.42-0.61,0.62
				c-1.05,1-2.42,1.58-3.86,1.65c-1.14,0.06-2.65,0.05-4.29-0.2c-4.19-0.62-9.18-2.76-10.64-9.23c0,0,2.07,0.33,2.81-1.27l0.15-1.8"
            />
            <path
              fill="none"
              stroke="#F6EB16"
              strokeMiterlimit="10"
              d="M2531.74,134.7c-0.13-0.63-2.42-10.77-8.97-15.76"
            />
            <line
              fill="none"
              stroke="#F6EB16"
              strokeMiterlimit="10"
              x1="2531.74"
              y1="134.7"
              x2="2531.75"
              y2="134.73"
            />
            <path
              fill="none"
              stroke="#F6EB16"
              strokeMiterlimit="10"
              d="M2515.3,124.48c0,0.01,0,0.01,0.01,0.02
				c2.26,8.42,7.68,12.3,7.68,12.3"
            />
            <line
              fill="none"
              stroke="#F6EB16"
              strokeMiterlimit="10"
              x1="2515.31"
              y1="124.5"
              x2="2515.31"
              y2="124.49"
            />
          </g>
        </g>
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2626.65,327.75l-61.61-14.36c-3.09-0.72-5.02-3.81-4.3-6.91
		l1.77-7.59c0.72-3.09,3.81-5.02,6.91-4.3l61.61,14.36c3.09,0.72,5.02,3.81,4.3,6.91l-1.77,7.59
		C2632.83,326.55,2629.74,328.47,2626.65,327.75z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2619.13,328.03l-7.23-1.92c0,0,4.92-8.33,5.43-20.42
		c0,0,5.25-0.08,7.23,1.92C2625.07,319.64,2619.13,328.03,2619.13,328.03z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2573.48,317.45l7.31,1.59c0,0-0.6-9.56,4.44-20.4
		c0,0-4.64-2.45-7.31-1.59C2572,307.38,2573.48,317.45,2573.48,317.45z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2627.92,309.53l-56.31-14.96c-4.07-1.08-6.49-5.26-5.41-9.32
		l4.89-18.39c1.08-4.07,5.26-6.49,9.32-5.41l56.31,14.96c4.07,1.08,6.49,5.26,5.41,9.32l-4.89,18.39
		C2636.16,308.19,2631.99,310.61,2627.92,309.53z"
        />
        <path
          fill="#F6EB16"
          stroke="#010101"
          strokeMiterlimit="10"
          d="M2630.79,300.16l-57.01-15.15c-4.46-1.19-7.11-5.76-5.93-10.22
		l3.99-15.01c1.19-4.46,5.76-7.11,10.22-5.93l57.01,15.15c4.46,1.19,7.11,5.76,5.93,10.22l-3.99,15.01
		C2639.82,298.69,2635.24,301.35,2630.79,300.16z"
        />
        <g id="XMLID_2_">
          <g>
            <path
              fill="#F6EB16"
              d="M2586.99,279.71c2.21,0.58,3.53,2.81,2.98,5.02l-0.27,1.05l-8.9-1.85l0.37-1.42
				c0.55-2.21,2.81-3.56,5.02-2.98L2586.99,279.71z"
            />
            <polygon
              fill="#F6EB16"
              points="2589.7,285.77 2587.4,294.97 2578.56,292.92 2579.94,287.32 2580.8,283.92 			"
            />
            <path
              fill="#F6EB16"
              d="M2587.4,294.97l-0.17,0.68c-0.55,2.21-2.81,3.56-5.02,2.98l-0.8-0.18c-2.21-0.58-3.56-2.81-3.01-5.02
				l1.53-6.1l-1.38,5.59L2587.4,294.97z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2580.8,283.92l0.37-1.42c0.55-2.21,2.81-3.56,5.02-2.98l0.8,0.18
				c2.21,0.58,3.53,2.81,2.98,5.02l-0.27,1.05"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2587.4,294.97l-0.17,0.68c-0.55,2.21-2.81,3.56-5.02,2.98
				l-0.8-0.18c-2.21-0.58-3.56-2.81-3.01-5.02l1.53-6.1"
            />
            <polygon
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              points="2579.94,287.32 2578.56,292.92 2587.4,294.97 
				2589.7,285.77 2580.8,283.92 			"
            />
          </g>
        </g>
        <g id="XMLID_1_">
          <g>
            <path
              fill="#F6EB16"
              d="M2624.62,288.69c2.24,0.43,3.7,2.62,3.27,4.86l-0.21,1.06l-8.98-1.39l0.29-1.43
				c0.43-2.24,2.59-3.7,4.83-3.27L2624.62,288.69z"
            />
            <polygon
              fill="#F6EB16"
              points="2627.67,294.61 2625.86,303.88 2616.89,302.32 2618.69,293.22 			"
            />
            <path
              fill="#F6EB16"
              d="M2625.86,303.88l-0.13,0.69c-0.46,2.24-2.62,3.7-4.86,3.27l-0.8-0.17c-2.24-0.43-3.7-2.62-3.27-4.86
				l0.09-0.49L2625.86,303.88z"
            />
          </g>
          <g>
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2618.69,293.22l0.29-1.43c0.43-2.24,2.59-3.7,4.83-3.27l0.8,0.17
				c2.24,0.43,3.7,2.62,3.27,4.86l-0.21,1.06"
            />
            <path
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              d="M2625.86,303.88l-0.13,0.69c-0.46,2.24-2.62,3.7-4.86,3.27
				l-0.8-0.17c-2.24-0.43-3.7-2.62-3.27-4.86l0.09-0.49"
            />
            <polygon
              fill="none"
              stroke="#010101"
              strokeMiterlimit="10"
              points="2616.89,302.32 2625.86,303.88 2627.67,294.61 
				2618.69,293.22 			"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    theme: selectThemeMode(state),
  };
};

export default connect(mapStateToProps)(BackgroundLogo);
